<template>
<div>
    <b-container>
        <b-row>
            <b-col class="headerpic">
                <img :src="wurl+'/imgsrv/'+this.headerpic">
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br>
                <b-breadcrumb :items="items"></b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="titleframecontainer">
                    <div class="titleframe">
                        {{ this.title }}
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row class="content">
            <b-col>
                <div v-html="content"></div>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import axios from 'axios'
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            items: [{
                    text: 'Accueil',
                    to: '/'
                },
                {
                    text: 'Accessoires',
                    active: true
                }
            ],
            content: '',
            title: '',
            headerpic:'ajaxloader.gif'
        }
    },
    methods: {
        retrievedata() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=content&p=accessoires&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('title is:'+ response.data.title)
                    // console.log('content is:'+ response.data.content)
                    console.log('headerpic is:' + response.data.headerpic)

                    this.title = response.data.title
                    this.content = response.data.content
                    this.headerpic = response.data.headerpic

                })
        },
        scrollToTop() {
            // scroll on top every load page        
            window.scrollTo(0, 0);
        }
    },
    mounted() {
        this.retrievedata()
        this.scrollToTop()
    }
}
</script>
